import React, { useState, useEffect } from 'react';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAppId } from "../context/AppIdContext";
import '../style/adminList.css';
import Header from '../component/header';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const Volunteers = () => {
    const { appId, userId, language } = useAppId();

    const lang = language || 'en';

    // Translation dictionary
    const t = {
        en: {
            title: "Volunteers",
            subtitle: "Manage platform volunteers and their activities.",
            addBtn: "Add Volunteer",
            cancelBtn: "Cancel",
            submitBtn: "Add Volunteer",
            addingBtn: "Adding...",
            updateBtn: "Update Volunteer",
            updatingBtn: "Updating...",
            viewProfile: "View Profile",
            addModalTitle: "Add New Volunteer",
            editModalTitle: "Edit Volunteer",
            nameLabel: "Full Name",
            mobileLabel: "Mobile Number",
            fillAllFields: "Please fill in all fields",
            validMobile: "Please enter a valid 10-digit mobile number",
            mobileRequired: "Mobile number is required",
            mobileLength: "Mobile number must be 10 digits",
            mobileNumeric: "Mobile number must contain only digits",
            mobileInvalid: "Please enter a valid Indian mobile number (starts with 6,7,8,9)",
            addSuccess: "Volunteer added successfully!",
            updateSuccess: "Volunteer updated successfully!",
            invalidMobile: "Invalid mobile no",
            searchPlaceholder: "Search by name or mobile...",
            noRecordsFound: "No volunteers found matching",
            loading: "Loading Data...",
            sendWhatsapp: "Send Responsibility in Whatsapp",
            sendSMS: "Send Responsibility in SMS",
            active: "ACTIVE",
            notActive: "NOT ACTIVE",
            error: "Error",
            failed: "Failed: ",
            addError: "Error adding volunteer.",
            updateError: "Error updating volunteer",
            // Delete text
            deleteConfirm: "Are you sure you want to delete this volunteer?",
            deleteSuccess: "Volunteer deleted successfully!",
            deleteFailed: "Failed to delete volunteer.",
            deleteError: "Error deleting volunteer.",
            userIdMissing: "Error: User ID is missing."
        },
        hi: {
            title: "स्वयंसेवक",
            subtitle: "प्लेटफॉर्म स्वयंसेवकों और उनकी गतिविधियों का प्रबंधन करें।",
            addBtn: "स्वयंसेवक जोड़ें",
            cancelBtn: "रद्द करें",
            submitBtn: "स्वयंसेवक जोड़ें",
            addingBtn: "जोड़ा जा रहा है...",
            updateBtn: "स्वयंसेवक अपडेट करें",
            updatingBtn: "अपडेट किया जा रहा है...",
            viewProfile: "प्रोफाइल देखें",
            addModalTitle: "नया स्वयंसेवक जोड़ें",
            editModalTitle: "स्वयंसेवक संपादित करें",
            nameLabel: "पूरा नाम",
            mobileLabel: "मोबाइल नंबर",
            fillAllFields: "कृपया सभी फ़ील्ड भरें",
            validMobile: "कृपया 10 अंकों का मोबाइल नंबर दर्ज करें।",
            mobileRequired: "मोबाइल नंबर आवश्यक है",
            mobileLength: "मोबाइल नंबर 10 अंकों का होना चाहिए",
            mobileNumeric: "मोबाइल नंबर में केवल अंक होने चाहिए",
            mobileInvalid: "कृपया एक वैध भारतीय मोबाइल नंबर दर्ज करें (6,7,8,9 से शुरू)",
            addSuccess: "स्वयंसेवक सफलतापूर्वक जोड़ा गया!",
            updateSuccess: "स्वयंसेवक सफलतापूर्वक अपडेट किया गया!",
            invalidMobile: "अमान्य मोबाइल नंबर",
            searchPlaceholder: "नाम या मोबाइल से खोजें...",
            noRecordsFound: "कोई स्वयंसेवक नहीं मिला",
            loading: "डेटा लोड हो रहा है...",
            sendWhatsapp: "व्हाट्सएप पर जिम्मेदारी भेजें",
            sendSMS: "एसएमएस पर जिम्मेदारी भेजें",
            active: "सक्रिय",
            notActive: "निष्क्रिय",
            error: "त्रुटि",
            failed: "विफल: ",
            addError: "स्वयंसेवक जोड़ने में त्रुटि।",
            updateError: "स्वयंसेवक अपडेट करने में त्रुटि",
            // Delete text
            deleteConfirm: "क्या आप वाकई इस स्वयंसेवक को हटाना चाहते हैं?",
            deleteSuccess: "स्वयंसेवक सफलतापूर्वक हटा दिया गया!",
            deleteFailed: "स्वयंसेवक को हटाने में विफल।",
            deleteError: "स्वयंसेवक को हटाने में त्रुटि।",
            userIdMissing: "त्रुटि: उपयोगकर्ता आईडी गायब है।"
        },
        gu: {
            title: "સ્વયંસેવકો",
            subtitle: "પ્લેટફોર્મ સ્વયંસેવકો અને તેમની પ્રવૃત્તિઓનું સંચાલન કરો.",
            addBtn: "સ્વયંસેવક ઉમેરો",
            cancelBtn: "રદ કરો",
            submitBtn: "સ્વયંસેવક ઉમેરો",
            addingBtn: "ઉમેરાઈ રહ્યું છે...",
            updateBtn: "સ્વયંસેવક અપડેટ કરો",
            updatingBtn: "અપડેટ થઈ રહ્યું છે...",
            viewProfile: "પ્રોફાઇલ જુઓ",
            addModalTitle: "નવો સ્વયંસેવક ઉમેરો",
            editModalTitle: "સ્વયંસેવક સંપાદિત કરો",
            nameLabel: "પૂરું નામ",
            mobileLabel: "મોબાઇલ નંબર",
            fillAllFields: "કૃપા કરીને બધા ફીલ્ડ ભરો",
            validMobile: "કૃપા કરીને 10 અંકનો માન્ય મોબાઇલ નંબર દાખલ કરો.",
            mobileRequired: "મોબાઇલ નંબર જરૂરી છે",
            mobileLength: "મોબાઇલ નંબર 10 અંકનો હોવો જોઈએ",
            mobileNumeric: "મોબાઇલ નંબરમાં માત્ર અંકો હોવા જોઈએ",
            mobileInvalid: "કૃપા કરીને માન્ય ભારતીય મોબાઇલ નંબર દાખલ કરો (6,7,8,9 થી શરૂ)",
            addSuccess: "સ્વયંસેવક સફળતાપૂર્વક ઉમેરાયો!",
            updateSuccess: "સ્વયંસેવક સફળતાપૂર્વક અપડેટ થયો!",
            invalidMobile: "અમાન્ય મોબાઇલ નંબર",
            searchPlaceholder: "નામ અથવા મોબાઇલથી શોધો...",
            noRecordsFound: "કોઈ સ્વયંસેવક મળ્યો નથી",
            loading: "ડેટા લોડ થઈ રહ્યો છે...",
            sendWhatsapp: "વોટ્સએપમાં જવાબદારી મોકલો",
            sendSMS: "એસએમએસમાં જવાબદારી મોકલો",
            active: "સક્રિય",
            notActive: "નિષ્ક્રિય",
            error: "ભૂલ",
            failed: "નિષ્ફળ: ",
            addError: "સ્વયંસેવક ઉમેરવામાં ભૂલ.",
            updateError: "સ્વયંસેવક અપડેટ કરવામાં ભૂલ",
            // Delete text
            deleteConfirm: "શું તમે ખરેખર આ સ્વયંસેવકને કાઢી નાખવા માંગો છો?",
            deleteSuccess: "સ્વયંસેવક સફળતાપૂર્વક કાઢી નાખવામાં આવ્યો!",
            deleteFailed: "સ્વયંસેવક કાઢી નાખવામાં નિષ્ફળ.",
            deleteError: "સ્વયંસેવક કાઢી નાખવામાં ભૂલ.",
            userIdMissing: "ભૂલ: વપરાશકર્તા ID ગુમ થયેલ છે."
        }
    };

    const txt = t[lang] || t['en'];

    // --- Logic State ---
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");

    // --- Mobile Search State ---
    const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);

    // --- Add Volunteer State ---
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState({ name: '', mobile_no: '' });
    const [mobileError, setMobileError] = useState("");

    // --- Edit Volunteer State ---
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editFormData, setEditFormData] = useState({ user_id: '', name: '', mobile_no: '' });
    const [editMobileError, setEditMobileError] = useState("");

    // --- Profile Detail Modal State ---
    const [selectedUser, setSelectedUser] = useState(null);

    // Mobile number validation function
    const validateMobileNumber = (number) => {
        if (!number) {
            return { isValid: false, message: txt.mobileRequired };
        }
        if (!/^\d{10}$/.test(number)) {
            return { isValid: false, message: txt.mobileLength };
        }
        if (!/^\d+$/.test(number)) {
            return { isValid: false, message: txt.mobileNumeric };
        }
        const firstDigit = number.charAt(0);
        if (!['6', '7', '8', '9'].includes(firstDigit)) {
            return { isValid: false, message: txt.mobileInvalid };
        }
        return { isValid: true, message: "" };
    };

    // --- API Fetching ---
    useEffect(() => {
        if (appId) { fetchUsers(); }
    }, [appId]);

    const fetchUsers = async () => {
        setLoading(true);
        try {
            const response = await axios.post(`${BASE_URL}/api/display_karyakarta`, { app_id: appId });
            if (response.data.success && response.data.data && response.data.data.result) {
                setUsers(response.data.data.result);
            } else {
                setUsers([]);
            }
        } catch (err) {
            console.error("API Error:", err);
            setUsers([]);
        } finally {
            setLoading(false);
        }
    };

    // --- Handlers ---
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        
        if (name === 'mobile_no') {
            const numericValue = value.replace(/[^0-9]/g, '');
            const limitedValue = numericValue.slice(0, 10);
            setFormData(prev => ({ ...prev, [name]: limitedValue }));
            
            if (mobileError) setMobileError("");
            
            if (limitedValue.length === 10) {
                const validation = validateMobileNumber(limitedValue);
                if (!validation.isValid) {
                    setMobileError(validation.message);
                } else {
                    setMobileError("");
                }
            } else if (limitedValue.length > 0 && limitedValue.length < 10) {
                setMobileError(txt.mobileLength);
            }
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleAddVolunteer = async (e) => {
        e.preventDefault();
        if (!formData.name || !formData.mobile_no) { 
            alert(txt.fillAllFields); 
            return; 
        }
        
        const validation = validateMobileNumber(formData.mobile_no);
        if (!validation.isValid) { 
            alert(validation.message);
            setMobileError(validation.message);
            return; 
        }

        setIsSubmitting(true);
        const payload = {
            app_id: appId,
            name: formData.name,
            mobile_no: formData.mobile_no,
            user_type: "k",  
            booth_no: "0",   
            booth_list: "",
            create_by: userId
        };

        try {
            const response = await axios.post(`${BASE_URL}/api/insert_user`, payload);
            if (response.data.success && response.data.data && response.data.data.Success == "1") {
                alert(txt.addSuccess);
                setIsModalOpen(false);
                setFormData({ name: '', mobile_no: '' });
                setMobileError("");
                fetchUsers();
            } else {
                alert("Mobile number already exists.");
            }
        } catch (error) {
            console.error("❌ Axios Error:", error);
            alert(txt.addError);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleEditClick = () => {
        if (selectedUser) {
            setEditFormData({
                user_id: selectedUser.user_id,
                name: selectedUser.name,
                mobile_no: selectedUser.mobile_no
            });
            setEditMobileError("");
            setSelectedUser(null);
            setIsEditModalOpen(true);
        }
    };

    const handleEditInputChange = (e) => {
        const { name, value } = e.target;
        
        if (name === 'mobile_no') {
            const numericValue = value.replace(/[^0-9]/g, '');
            const limitedValue = numericValue.slice(0, 10);
            setEditFormData(prev => ({ ...prev, [name]: limitedValue }));
            
            if (editMobileError) setEditMobileError("");
            
            if (limitedValue.length === 10) {
                const validation = validateMobileNumber(limitedValue);
                if (!validation.isValid) {
                    setEditMobileError(validation.message);
                } else {
                    setEditMobileError("");
                }
            } else if (limitedValue.length > 0 && limitedValue.length < 10) {
                setEditMobileError(txt.mobileLength);
            }
        } else {
            setEditFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleUpdateVolunteer = async (e) => {
        e.preventDefault();
        if (!editFormData.name || !editFormData.mobile_no) { 
            alert(txt.fillAllFields); 
            return; 
        }
        
        const validation = validateMobileNumber(editFormData.mobile_no);
        if (!validation.isValid) { 
            alert(validation.message);
            setEditMobileError(validation.message);
            return; 
        }
        
        setIsEditing(true);
        
        const payload = {
            user_id: editFormData.user_id,
            app_id: appId,
            name: editFormData.name,
            mobile_no: editFormData.mobile_no,
            user_type: "k",
            booth_no: "0",
            booth_list: "",
            create_by: userId 
        };
        
        try {
            const response = await axios.post(`${BASE_URL}/api/update_user`, payload);
            if (response.data.success && response.data.data && response.data.data.Success == "1") {
                alert(txt.updateSuccess);
                setIsEditModalOpen(false);
                setEditMobileError("");
                fetchUsers();
            } else {
                alert(response.data.data?.Message || txt.invalidMobile);
            }
        } catch (error) {
            console.error("Axios Error:", error);
            alert(txt.updateError);
        } finally {
            setIsEditing(false);
        }
    };

    // --- Delete Handler ---
    const handleDeleteAdmin = async (id) => {
        if (!id) {
            alert(txt.userIdMissing);
            return;
        }

        if (window.confirm(txt.deleteConfirm)) {
            try {
                const response = await axios.post(`${BASE_URL}/api/dlt_user`, {
                    app_id: appId,
                    user_id: id,
                    delete_by: userId 
                });

                if (response.data.success || response.data.Success == "1" || (response.data.data && response.data.data.Success == "1")) {
                    alert(txt.deleteSuccess);
                    setSelectedUser(null);
                    fetchUsers();
                } else {
                    alert(response.data.message || response.data.Message || response.data.data?.Message || txt.deleteFailed);
                }
            } catch (error) {
                console.error("Delete Error:", error);
                alert(txt.deleteError);
            }
        }
    };

    const filteredUsers = (users || []).filter(user => {
        if (!searchTerm) return true;
        const lowerSearch = searchTerm.toLowerCase();
        return (
            (user.name && user.name.toLowerCase().includes(lowerSearch)) ||
            (user.mobile_no && user.mobile_no.includes(lowerSearch))
        );
    });

    if (loading) {
        return (
            // --- THE FIX: Wrapping loader in app-container and Header so layout stays visible ---
            <div className={`app-container p-4`}>
                <Header title={txt.title} />
                <div className="loader-wrapper">
                    <div className="spinner"></div>
                    <p className="loader-text">{txt.loading}</p>
                    <style jsx>{`
                        .app-container { background: #E5E7EB; min-height: 100vh; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; }
                        .loader-wrapper { display: flex; flex-direction: column; justify-content: center; align-items: center; min-height: 60vh; width: 100%; }
                        .spinner { width: 50px; height: 50px; border: 4px solid #E5E7EB; border-top: 4px solid #2563EB; border-radius: 50%; animation: spin 1s linear infinite; margin-bottom: 16px; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1); }
                        .loader-text { color: #6B7280; font-weight: 500; font-size: 1.1rem; animation: pulse 1.5s ease-in-out infinite; }
                        @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
                        @keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.5; } }
                    `}</style>
                </div>
            </div>
        );
    }

    return (
        <>
            {/* Add Volunteer Modal */}
            {isModalOpen && (
                <div className="modal-overlay">
                    <div className="modal-content-box" style={{ maxWidth: '400px' , padding:'0px'}}>
                        <div className="modal-header" style={{ padding: '24px 24px 0px 24px' }}>
                            <div><h2>{txt.addModalTitle}</h2></div>
                            {/* --- THE FIX IS ON THIS X CLOSE BUTTON --- */}
                            <button className="close-btn-icon" onClick={() => { setIsModalOpen(false); setFormData({ name: '', mobile_no: '' }); setMobileError(""); }}>✕</button>
                        </div>
                        <form onSubmit={handleAddVolunteer}>
                            <div className="modal-body-grid" style={{ display: 'flex', flexDirection: 'column', gap: '15px', padding: '20px 24px' }}>
                                <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                    <label style={{ fontSize: '14px', fontWeight: '600', color: '#374151' }}>{txt.nameLabel}</label>
                                    <input type="text" name="name" value={formData.name} onChange={handleInputChange} className="form-input" style={{ padding: '10px 15px', borderRadius: '8px', border: '1px solid #d1d5db', outline: 'none' }} required />
                                </div>
                                <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                    <label style={{ fontSize: '14px', fontWeight: '600', color: '#374151' }}>{txt.mobileLabel}</label>
                                    <input 
                                        type="text" 
                                        name="mobile_no" 
                                        value={formData.mobile_no} 
                                        onChange={handleInputChange} 
                                        maxLength="10" 
                                        className="form-input" 
                                        style={{ 
                                            padding: '10px 15px', 
                                            borderRadius: '8px', 
                                            border: mobileError ? '1px solid #ef4444' : '1px solid #d1d5db',
                                            outline: 'none' 
                                        }} 
                                        required 
                                    />
                                    {mobileError && (
                                        <div style={{ fontSize: '12px', color: '#ef4444', marginTop: '4px' }}>
                                            {mobileError}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="modal-footer" style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', padding: '0px 24px 24px 24px' }}>
                                {/* --- THE FIX IS ON THIS CANCEL BUTTON --- */}
                                <button type="button" className="btn-cancel" onClick={() => { setIsModalOpen(false); setFormData({ name: '', mobile_no: '' }); setMobileError(""); }} style={{ padding: '10px 20px', borderRadius: '8px', border: '1px solid #d1d5db', background: 'white', cursor: 'pointer' }}>{txt.cancelBtn}</button>
                                <button type="submit" className="btn-search-main" disabled={isSubmitting} style={{ padding: '10px 20px', borderRadius: '8px', border: 'none', background: '#2563eb', color: 'white' }}>{isSubmitting ? txt.addingBtn : txt.submitBtn}</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Edit Volunteer Modal */}
            {isEditModalOpen && (
                <div className="modal-overlay">
                    <div className="modal-content-box" style={{ maxWidth: '400px', padding:'0px'}}>
                        <div className="modal-header" style={{ padding: '24px 24px 0px 24px' }}>
                            <div><h2>{txt.editModalTitle}</h2></div>
                            <button className="close-btn-icon" onClick={() => setIsEditModalOpen(false)}>✕</button>
                        </div>
                        <form onSubmit={handleUpdateVolunteer}>
                            <div className="modal-body-grid" style={{ display: 'flex', flexDirection: 'column', gap: '15px', padding: '20px 24px' }}>
                                <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                    <label style={{ fontSize: '14px', fontWeight: '600', color: '#374151' }}>{txt.nameLabel}</label>
                                    <input type="text" name="name" value={editFormData.name} onChange={handleEditInputChange} className="form-input" style={{ padding: '10px 15px', borderRadius: '8px', border: '1px solid #d1d5db', outline: 'none' }} required />
                                </div>
                                <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                    <label style={{ fontSize: '14px', fontWeight: '600', color: '#374151' }}>{txt.mobileLabel}</label>
                                    <input 
                                        type="text" 
                                        name="mobile_no" 
                                        value={editFormData.mobile_no} 
                                        onChange={handleEditInputChange} 
                                        maxLength="10" 
                                        className="form-input" 
                                        style={{ 
                                            padding: '10px 15px', 
                                            borderRadius: '8px', 
                                            border: editMobileError ? '1px solid #ef4444' : '1px solid #d1d5db',
                                            outline: 'none' 
                                        }} 
                                        required 
                                    />
                                    {editMobileError && (
                                        <div style={{ fontSize: '12px', color: '#ef4444', marginTop: '4px' }}>
                                            {editMobileError}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="modal-footer" style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', padding: '0px 24px 24px 24px' }}>
                                <button type="button" className="btn-cancel" onClick={() => setIsEditModalOpen(false)} style={{ padding: '10px 20px', borderRadius: '8px', border: '1px solid #d1d5db', background: 'white', cursor: 'pointer' }}>{txt.cancelBtn}</button>
                                <button type="submit" className="btn-search-main" disabled={isEditing} style={{ padding: '10px 20px', borderRadius: '8px', border: 'none', background: '#f59e0b', color: 'white', cursor: isEditing ? 'not-allowed' : 'pointer' }}>{isEditing ? txt.updatingBtn : txt.updateBtn}</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Profile Detail Modal */}
            {selectedUser && (
                <div className="modal-overlay" onClick={() => setSelectedUser(null)}>
                    <div className="profile-detail-container" onClick={(e) => e.stopPropagation()}>
                        <button className="profile-close-btn" onClick={() => setSelectedUser(null)}>
                            <svg width="24" height="24" fill="none" stroke="white" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                        </button>
                        <div className="profile-detail-card">
                            <div className="profile-avatar-wrapper">
                                <div className="profile-avatar-bg">
                                    <img src={selectedUser.photo ? selectedUser.photo : `https://ui-avatars.com/api/?name=${encodeURIComponent(selectedUser.name)}&background=e5e5e5&color=a3a3a3`} alt={selectedUser.name} />
                                </div>
                            </div>
                            <div className="profile-content">
                                <h2 className="profile-name">{selectedUser.name}</h2>
                                <p className="profile-mobile">{selectedUser.mobile_no}</p>
                                <div className="profile-big-btns">
                                    <a href={`https://wa.me/91${selectedUser.mobile_no}?text=${encodeURIComponent('Hello ' + selectedUser.name + ', here is your responsibility details.')}`} target="_blank" rel="noreferrer" className="btn-resp btn-wa"><svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>{txt.sendWhatsapp}</a>
                                    <a href={`sms:${selectedUser.mobile_no}`} className="btn-resp btn-sms-big"><svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2 2z"></path></svg>{txt.sendSMS}</a>
                                </div>
                            </div>
                            <div className="profile-bottom-bar" style={{ display: 'flex', justifyContent: 'space-evenly', background: '#213555', padding: '10px', borderRadius: '0 0 20px 20px' }}>
                                <a href={`tel:${selectedUser.mobile_no}`} className="btm-icon-wrapper" style={{ color: '#0ea5e9' }}><svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" /></svg></a>
                                <div className="divider"></div>
                                <a href={`https://wa.me/91${selectedUser.mobile_no}`} target="_blank" rel="noreferrer" className="btm-icon-wrapper" style={{ color: '#22c55e' }}><svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg></a>
                                <div className="divider"></div>
                                <a href={`sms:${selectedUser.mobile_no}`} className="btm-icon-wrapper" style={{ color: '#3b82f6', position: 'relative' }}>
                                    <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 10H6v-2h12v2zm0-3H6V7h12v2z"/></svg>
                                    <span style={{ position: 'absolute', fontSize: '7px', color: 'white', fontWeight: 'bold', marginTop: '-2px' }}></span>
                                </a>
                                <div className="divider"></div>
                                <button className="btm-icon-wrapper" onClick={handleEditClick} style={{ background: 'none', border: 'none', padding: 0, color: '#f59e0b' }}><svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" /></svg></button>
                                <div className="divider"></div>
                                <button className="btm-icon-wrapper" onClick={() => handleDeleteAdmin(selectedUser.user_id || selectedUser.id)} style={{ background: 'none', border: 'none', padding: 0, color: '#ef4444' }}><svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" /></svg></button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <style jsx>{`
                /* --- PROFESSIONAL FILTER CONTAINER --- */
                .filter-container { display: flex; justify-content: space-between; align-items: center; gap: 16px; margin-bottom: 24px; background: transparent; }
                .action-group { display: flex; align-items: center; gap: 12px; }

                /* Mobile Search Trigger Button */
                .mobile-search-trigger { display: none; }
                .close-search-btn { display: none; }
                .search-wrapper { position: relative; flex: 1; max-width: 400px; }
                .search-icon { position: absolute; left: 14px; top: 50%; transform: translateY(-50%); color: #94a3b8; width: 20px; height: 20px; }
                .search-input { width: 100%; padding: 12px 16px 12px 42px; border: 1px solid #e2e8f0; border-radius: 10px; font-size: 14px; color: #1e293b; background-color: #ffffff; outline: none; transition: all 0.2s ease; box-shadow: 0 1px 2px rgba(0,0,0,0.05); }
                .search-input:focus { border-color: #2563eb; box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1); }

                .btn-add-user { display: flex; align-items: center; justify-content: center; gap: 8px; background-color: #2563eb; color: #ffffff; padding: 12px 20px; border: none; border-radius: 10px; font-size: 14px; font-weight: 600; cursor: pointer; transition: all 0.2s ease; box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.2); white-space: nowrap; }
                .btn-add-user:hover { background-color: #1d4ed8; transform: translateY(-1px); box-shadow: 0 6px 8px -1px rgba(37, 99, 235, 0.3); }

                /* --- NEW: MODERN ADMIN CARD STYLES --- */
                .user-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(260px, 1fr)); gap: 24px; margin-top: 20px; }

                .modern-user-card { background: #ffffff; border-radius: 16px; padding: 24px 20px; display: flex; flex-direction: column; align-items: center; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03); border: 1px solid #f1f5f9; transition: all 0.3s ease; position: relative; cursor: pointer; height: 100%; }
                .modern-user-card:hover { transform: translateY(-5px); box-shadow: 0 12px 20px -5px rgba(0, 0, 0, 0.08); border-color: #e2e8f0; }

                .card-header-dots { position: absolute; top: 16px; right: 16px; color: #94a3b8; padding: 4px; border-radius: 50%; transition: 0.2s; }
                .card-header-dots:hover { background: #f1f5f9; color: #1e293b; }

                .modern-card-avatar { 
                    width: 80px; height: 80px; border-radius: 50%; padding: 3px; 
                    background: #e2e8f0;
                    margin-bottom: 16px; 
                }
                .modern-card-avatar img { width: 100%; height: 100%; border-radius: 50%; object-fit: cover; border: none; }

                .modern-card-name { font-size: 1.1rem; font-weight: 700; color: #0f172a; margin: 0 0 8px 0; text-align: center; }

                .modern-card-phone { display: flex; align-items: center; gap: 6px; font-size: 0.9rem; color: #64748b; background: #f8fafc; padding: 6px 12px; border-radius: 20px; margin-bottom: 20px; font-weight: 500; }
                .modern-card-phone .phone-icon { color: #3b82f6; }

                .modern-btn-view { width: 100%; padding: 10px; background: #f1f5f9; color: #3b82f6; border: none; border-radius: 10px; font-weight: 600; font-size: 0.9rem; transition: all 0.2s ease; margin-top: auto; }
                .modern-btn-view:hover { background: #3b82f6; color: #ffffff; }

                /* Mobile Optimization */
                @media (max-width: 640px) {
                    .filter-container { flex-direction: row; align-items: center; gap: 8px; }
                    .search-wrapper { display: block; flex: 1; max-width: none; }
                    .search-input { padding: 10px 16px 10px 36px; font-size: 13px; padding-right: 40px; }
                    .search-icon { left: 10px; width: 16px; height: 16px; }
                    .close-search-btn { display: block; position: absolute; right: 8px; top: 50%; transform: translateY(-50%); background: #f1f5f9; border: none; color: #64748b; padding: 4px; border-radius: 50%; cursor: pointer; display: flex; align-items: center; justify-content: center; z-index: 2; }
                    .action-group { width: auto; flex-shrink: 0; }
                    .btn-add-user { width: auto; padding: 10px 12px; font-size: 13px; gap: 4px; height: 46px; }
                    .btn-add-user svg { width: 16px; height: 16px; }
                    .mobile-search-trigger { display: none; }
                    .user-grid { grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); gap: 16px; }
                    .modal-content-box { padding: 0px; }
                    .profile-content { padding: 15px 16px 20px 16px; }
                    .btn-resp { font-size: 13px; padding: 12px; }
                    .profile-name { font-size: 18px; }
                    .profile-mobile { font-size: 14px; }
                }

                .blur-background { filter: blur(4px); pointer-events: none; }

                /* MODAL RESPONSIVE FIXES */
                .modal-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0, 0, 0, 0.6); display: flex; align-items: center; justify-content: center; z-index: 1000; padding: 20px; box-sizing: border-box; }
                .modal-content-box { background: white; border-radius: 12px; width: 100%; box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1); padding: 24px; box-sizing: border-box; }
                .modal-header { display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #e5e7eb; padding: 15px; margin-bottom: 10px; }
                .modal-header h2 { margin: 0; font-size: 1.25rem; color: #111827; }
                .close-btn-icon { background: none; border: none; cursor: pointer; color: #6b7280; }
                .close-btn-icon:hover { color: #111827; }
                .profile-detail-container { position: relative; width: 100%; max-width: 380px; margin-top: 50px; }
                .profile-close-btn { position: absolute; top: -40px; right: -10px; background: none; border: none; cursor: pointer; padding: 5px; z-index: 10; }
                .profile-detail-card { background: white; border-radius: 20px; display: flex; flex-direction: column; overflow: visible; box-shadow: 0 15px 35px rgba(0,0,0,0.2); }
                .profile-avatar-wrapper { display: flex; justify-content: center; margin-top: -55px; }
                .profile-avatar-bg { width: 110px; height: 110px; background: white; border-radius: 50%; padding: 6px; }
                .profile-avatar-bg img { width: 100%; height: 100%; border-radius: 50%; object-fit: cover; }
                .profile-content { padding: 15px 24px 25px 24px; text-align: center; }
                .profile-name { font-size: 22px; font-weight: 800; color: #111827; text-transform: uppercase; margin: 0; }
                .profile-mobile { font-size: 16px; color: #374151; margin: 8px 0 24px 0; letter-spacing: 0.5px; font-weight: 500; }
                .profile-big-btns { display: flex; flex-direction: column; gap: 12px; }
                .btn-resp { display: flex; align-items: center; justify-content: center; gap: 10px; width: 100%; padding: 14px; border-radius: 50px; color: white; font-weight: 600; text-decoration: none; font-size: 15px; transition: transform 0.2s, box-shadow 0.2s; border: none; box-sizing: border-box; }
                .btn-resp:hover { transform: translateY(-2px); box-shadow: 0 4px 10px rgba(0,0,0,0.15); color: white; }
                .btn-wa { background-color: #4ade80; } .btn-sms-big { background-color: #f59e0b; }
                .profile-bottom-bar { background-color: #213555; border-radius: 0 0 20px 20px; display: flex; justify-content: space-evenly; align-items: center;}
                .divider { width: 1px; height: 24px; background-color: rgba(255, 255, 255, 0.3); }
                .btm-icon-wrapper { background: none; border: none; padding: 0; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: transform 0.2s; }
                .btm-icon-wrapper:hover { transform: scale(1.1); }
            `}</style>

            <div className={`app-container p-4 ${isModalOpen || isEditModalOpen || selectedUser ? 'blur-background' : ''}`}>
                
                <Header title={txt.title}/>

                <div className="filter-container mt-3">
                    <div className={`search-wrapper ${isMobileSearchOpen ? 'mobile-open' : ''}`}>
                        <svg className="search-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
                        <input
                            type="text"
                            className="search-input"
                            placeholder={txt.searchPlaceholder}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <button className="close-search-btn" onClick={() => { setIsMobileSearchOpen(false); setSearchTerm(''); }}>
                            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                        </button>
                    </div>

                    <div className="action-group">
                        {!isMobileSearchOpen && (
                            <button className="mobile-search-trigger" onClick={() => setIsMobileSearchOpen(true)}>
                                <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
                            </button>
                        )}
                        <button className="btn-add-user" onClick={() => setIsModalOpen(true)}>
                            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                            </svg>
                            {txt.addBtn}
                        </button>
                    </div>
                </div>

                <div className="user-grid">
                    {filteredUsers.length > 0 ? (
                        filteredUsers.map((user) => (
                            <div key={user.id} className="modern-user-card" onClick={() => setSelectedUser(user)}>
                                <div className="card-header-dots">
                                    <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M12 13a1 1 0 100-2 1 1 0 000 2zM12 7a1 1 0 100-2 1 1 0 000 2zM12 19a1 1 0 100-2 1 1 0 000 2z" />
                                    </svg>
                                </div>
                                <div className="modern-card-avatar">
                                    <img 
                                        src={user.photo ? user.photo : `https://ui-avatars.com/api/?name=${encodeURIComponent(user.name)}&background=ffffff&color=0f172a`} 
                                        alt={user.name} 
                                    />
                                </div>
                                <h3 className="modern-card-name">{user.name}</h3>
                                <div className="modern-card-phone">
                                    <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24" className="phone-icon">
                                        <path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                    </svg>
                                    {user.mobile_no}
                                </div>
                                <button className="modern-btn-view" onClick={(e) => { e.stopPropagation(); setSelectedUser(user); }}>
                                    {txt.viewProfile}
                                </button>
                            </div>
                        ))
                    ) : (
                        <div className="no-results" style={{ gridColumn: "1 / -1", textAlign: "center", padding: "40px", color: "#6b7280" }}>
                            {searchTerm ? `${txt.noRecordsFound} "${searchTerm}"` : "No volunteers found"}
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default Volunteers;